export default "__VITE_ASSET__CQCHoxQD__"